/* EXPORT ENTITY TYPES */
export * from './user-preference/user-preference'
export * from './page-preference/page-preference'

/* IMPORT ENTITIES AND RESOLVERS */
import {
  entities as UserPreferenceEntities,
  resolvers as UserPreferenceResolvers,
  subscribers as UserPreferenceSubscribers
} from './user-preference'
import { entities as PagePreferenceEntities, resolvers as PagePreferenceResolvers } from './page-preference'

export const entities = [
  /* ENTITIES */
  ...UserPreferenceEntities,
  ...PagePreferenceEntities
]

export const subscribers = [
  /* SUBSCRIBERS */
  ...UserPreferenceSubscribers
]

export const schema = {
  resolverClasses: [
    /* RESOLVER CLASSES */
    ...UserPreferenceResolvers,
    ...PagePreferenceResolvers
  ]
}
